module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/go-to-df578124a6f386f96c34f8f7fd8ee3de.svg";